export const TOOLTIP_SHOW_TIMEOUT = 2000;
